export const environment = {
  production: false,
  BASE_URL: 'https://ikdevserver.kuba.no/api/kuba/v1',
  BASE_CRM_URL: 'https://crm.kuba.no/nb/',
  BASE_FRONT_URL: 'https://ikdev.kuba.no/',
  BASE_ASSET_PATH: '/assets',
  BASE_STYLES_PATH: '/assets/styles',
  NOTIFICATION_URL: 'https://ikdevserver.kuba.no',
};
